import React from 'react';
import { TwitterButtonStyle } from './styles';
import { TwitterShareButton } from 'react-share';

export const ShareOnTwitter = ({ url, title }) => (
  <TwitterShareButton url={url} title={title}>
    <TwitterButtonStyle>
      <i className="fa-brands fa-twitter"></i>Share
    </TwitterButtonStyle>
  </TwitterShareButton>
);
